<template>
    <div class="progressBar">
        <div class="outBar">
            <div class="innerBar" :style="{width:innerBarWidth}"></div>
        </div>
        <div class="speed">
            <span>{{current}}</span>/{{total}}
        </div>
    </div>
</template>
<script>
export default {
  data() {
    return {

    };
  },
  props: {
    current: {
      type: Number,
      default: 0,
    },
    total: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    innerBarWidth() {
      return `${(this.current / this.total) * 100}%`;
    },
  },
};
</script>
<style lang="scss" scoped>
.progressBar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 60px;
    padding: 0 36px;
    font-size: 25px;
    .outBar {
        width: 88%;
        height: 11px;
        overflow: hidden;
        background: #F5F5F5;
        border-radius: 7px;
        .innerBar {
            height: inherit;
            background-color: #FF7F41;
            border-radius: inherit;
            transition: width 0.5s ease-out;
        }
    }
}
</style>
